import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      background: '#0A0F0B',
      padding: 'clamp(48px, 6vw, 64px) clamp(20px, 4vw, 52px) 28px',
    }}>
      <div style={{
        maxWidth: '1160px', margin: '0 auto',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '40px', paddingBottom: '48px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}>
          <div>
            <a href="/" style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '28px', fontWeight: 700, color: '#fff',
              textDecoration: 'none', display: 'block', marginBottom: '14px',
            }}>Gracious</a>
            <p style={{
              fontSize: '13px', color: 'rgba(255,255,255,0.4)',
              lineHeight: 1.75, maxWidth: '260px',
            }}>
              Building Wealth. Building Health. Building You. One venture at a time.
            </p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              {[
                { href: 'https://wa.me/2347069495976', label: 'WA' },
                { href: '#', label: 'IG' },
                { href: '#', label: 'FB' },
              { href: 'https://tiktok.com/@kentoto21', label: 'TT' },
              ].map(({ href, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" style={{
                  width: '36px', height: '36px', borderRadius: '10px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'rgba(255,255,255,0.5)', textDecoration: 'none',
                  fontSize: '11px', fontWeight: 700,
                  fontFamily: "'Inter', sans-serif",
                  transition: 'all 0.25s',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = '#C9973A';
                  e.currentTarget.style.color = '#C9973A';
                  e.currentTarget.style.background = 'rgba(201,151,58,0.1)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                  e.currentTarget.style.color = 'rgba(255,255,255,0.5)';
                  e.currentTarget.style.background = 'transparent';
                }}
                >{label}</a>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '11px', fontWeight: 700, letterSpacing: '2.5px',
              textTransform: 'uppercase', color: '#C9973A', marginBottom: '20px',
            }}>Navigate</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[['/', 'Home'], ['#about', 'About'], ['#ventures', 'Ventures'], ['/blog', 'Blog'], ['#contact', 'Contact'], ['https://tiktok.com/@kentoto21', 'TikTok']].map(([href, label]) => (
                <li key={label}>
                  <a href={href} style={{
                    fontSize: '14px', color: 'rgba(255,255,255,0.45)',
                    textDecoration: 'none', transition: 'color 0.2s',
                    fontFamily: "'Inter', sans-serif",
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}
                  >{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '11px', fontWeight: 700, letterSpacing: '2.5px',
              textTransform: 'uppercase', color: '#C9973A', marginBottom: '20px',
            }}>Ventures</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                ['https://ideraherbals.com.ng', 'Herbal & Wellness'],
                ['#', 'Real Estate'],
                ['#', 'Digital Marketing'],
                ['#', 'MLM Coaching'],
              ].map(([href, label]) => (
                <li key={label}>
                  <a href={href} style={{
                    fontSize: '14px', color: 'rgba(255,255,255,0.45)',
                    textDecoration: 'none', transition: 'color 0.2s',
                    fontFamily: "'Inter', sans-serif",
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}
                  >{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '11px', fontWeight: 700, letterSpacing: '2.5px',
              textTransform: 'uppercase', color: '#C9973A', marginBottom: '20px',
            }}>Get In Touch</h4>
            <a href="https://wa.me/2347069495976" target="_blank" rel="noreferrer" style={{
              display: 'inline-flex', alignItems: 'center', gap: '10px',
              padding: '12px 20px', borderRadius: '12px',
              background: 'rgba(37,211,102,0.12)',
              border: '1px solid rgba(37,211,102,0.2)',
              color: '#25D366', textDecoration: 'none',
              fontFamily: "'Inter', sans-serif",
              fontSize: '13px', fontWeight: 600,
              transition: 'all 0.25s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,211,102,0.2)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(37,211,102,0.12)'}
            >
              💬 Chat on WhatsApp
            </a>
          </div>
        </div>

        <div style={{
          paddingTop: '24px',
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: '12px',
        }}>
          <p style={{
            fontSize: '12px', color: 'rgba(255,255,255,0.25)',
            fontFamily: "'Inter', sans-serif",
          }}>
            © 2026 Gracious. All rights reserved. | gracioushub.com.ng
          </p>
          <p style={{
            fontSize: '11px', color: 'rgba(255,255,255,0.2)',
            fontFamily: "'Inter', sans-serif",
          }}>
            Built by Dee-Digital Solution
          </p>
        </div>
      </div>
    </footer>
  );
}
